import { SYSTEM_PAYMENT_TERMINALS_ROUTE } from 'subdomains/cpo/router/routes';

export const systemMenuDefinitions = [
  {
    id: 'system_new', // temporary until we remove the existing `system`
    title: (t) => t('menu.system.main', 'Main Menu'),
    items: [
      {
        content: (t) => t('menu.system.providers.main', 'Providers'),
        icon: 'building',
        to: '/system/providers',
        slug: 'system-providers',
        endpoint: 'system/providers',
        requiresFeatureFlag: 'system_menu_providers',
        systemRolesOnly: true,
      },
      {
        content: (t) => t('menu.system.finance.main', 'Finance'),
        icon: 'coins',
        to: '/system/finance',
        slug: 'system-finance',
        endpoint: 'system/finance',
        systemRolesOnly: true,
        subItems: [
          {
            content: (t) => t('menu.system.finance.invoices', 'Invoices'),
            icon: 'file-invoice',
            to: '/system/finance/invoices',
            slug: 'system-invoices',
            endpoint: 'system/finance/invoices',
            requiresFeatureFlag: 'system_menu_finance_invoices',
            systemRolesOnly: true,
          },
          {
            content: (t) => t('menu.system.finance.roaming', 'Roaming'),
            icon: 'globe',
            to: '/system/finance/roaming',
            slug: 'system-roaming',
            endpoint: 'system/finance/roaming',
            requiresFeatureFlag: 'system_menu_finance_roaming',
            systemRolesOnly: true,
          },
          {
            content: (t) =>
              t('menu.system.finance.exchangeRates', 'Exchange Rates'),
            icon: 'chart-line',
            to: '/system/finance/exchange-rates',
            slug: 'system-exchange-rates',
            endpoint: 'system/finance/exchangeRates',
            requiresFeatureFlag: 'system_menu_finance_exchange_rates',
            systemRolesOnly: true,
          },
          {
            content: (t) =>
              t(
                'menu.system.finance.roamingCpoCostOverride',
                'Roaming overrides'
              ),
            icon: 'globe',
            to: '/system/finance/roaming-overrides',
            slug: 'system-roaming-overrides',
            endpoint: 'system/finance/roamingOverrides',
            requiresFeatureFlag: 'system_menu_finance_roaming_overrides',
            systemRolesOnly: true,
          },
          {
            content: (t) =>
              t('menu.system.finance.roamingLimits', 'Roaming limits'),
            icon: 'thumbtack',
            to: '/system/finance/roaming-limits',
            slug: 'system-roaming-limits',
            endpoint: 'system/finance/roamingLimits',
            requiresFeatureFlag: 'system_menu_finance_roaming_limits',
            systemRolesOnly: true,
          },
        ],
      },
      {
        content: (t) =>
          t('menu.system.global.chargingStations', 'Charging stations'),
        icon: 'charging-station',
        to: '/search/charging-stations',
        slug: 'system-charging-stations',
        endpoint: 'system/search/charging-stations',
        providerOrGlobalRolesOnly: true,
        subItems: [
          {
            content: (t) => t('menu.paymentTerminals', 'Payment Terminals'),
            icon: 'tablet',
            to: SYSTEM_PAYMENT_TERMINALS_ROUTE,
            slug: 'system-payment-terminals',
            endpoint: 'system/search/paymentTerminals',
            providerOrGlobalRolesOnly: true,
          },
        ],
      },

      // Note: This is temporarily placed here until the System Menu Finance feature flags are enabled.
      // The menu item is only accessible to System Admins.
      {
        content: (t) =>
          t('menu.system.finance.billingEntities', 'Billing Entities'),
        icon: 'money-bill-wave',
        to: '/system/finance/billing-entities',
        slug: 'system-billing-entities',
        endpoint: 'system/billingEntities',
        systemRolesOnly: true,
      },
      {
        content: (t) => t('menu.system.finance.cpoSessions', 'CPO Sessions'),
        icon: 'bars-staggered',
        to: '/search/cpo-sessions',
        slug: 'system-sessions-cpo',
        endpoint: 'system/search/sessions-cpo',
        systemRolesOnly: true,
      },
      {
        content: (t) => t('menu.system.finance.mspSessions', 'MSP Sessions'),
        icon: 'bars-staggered',
        to: '/search/msp-sessions',
        slug: 'system-sessions-msp',
        endpoint: 'system/search/sessions-msp',
        systemRolesOnly: true,
      },
      {
        content: (t) => t('menu.system.migrations', 'Migrations'),
        icon: 'clone',
        to: '/system/migrations/enterprise-accounts',
        slug: 'system-migrations',
        endpoint: 'enterprise-account-migrations',
        efluxOnly: true,
        superAdminOnly: true,
        requiresFeatureFlag: 'system_menu_enterprise_account_migrations',
      },
    ],
  },
];
